var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',[_vm._v("P gets on the bus but he has no idea where this clinic is located and he’s out of data on his phone. He’s feeling kinda embarrassed that he’ll have to ask the bus driver for directions.")])])}
var staticRenderFns = []

export { render, staticRenderFns }